import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShoppingBag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shopping-bag-1"} maskId="square-filled-radius-0-stroke-1-IconShoppingBag1"><path fillRule="evenodd" clipRule="evenodd" d="M4.02757 3H19.9705L21.0293 21H2.96875L4.02757 3ZM8.99902 7.5V7H7.99902V7.5C7.99902 9.70914 9.78988 11.5 11.999 11.5C14.2082 11.5 15.999 9.70914 15.999 7.5V7H14.999V7.5C14.999 9.15685 13.6559 10.5 11.999 10.5C10.3422 10.5 8.99902 9.15685 8.99902 7.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShoppingBag1;
